import { categories } from "@/mocks/categories";
import { events } from "@/mocks/events";
import { blacklist } from "@/mocks/blacklist";

export function getCategoryById(id: string) {
  return categories.find((c) => c.id === id);
}

export function getEventById(id: string) {
  return events.find((e) => e.id === id);
}

export function getEventsByCategory(categoryId: string) {
  return events.filter((e) => e.categoryId === categoryId);
}

export function getBlacklistByEvent(eventId: string) {
  return blacklist.find((b) => b.eventId === eventId);
}

export function getCategoryName(id: string) {
  return getCategoryById(id)?.name ?? id;
}

export function formatDate(date: string) {
  const [, m, d] = date.split("-");
  return `${Number(m)}月${Number(d)}日`;
}

export const statusLabels: Record<string, string> = {
  upcoming: "未开始",
  live: "进行中",
  ended: "已结束",
};

export const statusStyles: Record<string, string> = {
  upcoming: "bg-secondary-100 text-secondary-800",
  live: "bg-accent-100 text-accent-800",
  ended: "bg-foreground-100 text-foreground-700",
};

export function relatedEvents(eventId: string, categoryId: string, limit = 3) {
  const sameCategory = events.filter((e) => e.categoryId === categoryId && e.id !== eventId);
  const others = events.filter((e) => e.categoryId !== categoryId && e.id !== eventId);
  return [...sameCategory, ...others].slice(0, limit);
}